import { useState, useEffect, useRef } from "react";
import Image from "next/image";
import classNames from "classnames";
import ImgixLoader from "@utils/images/ImgixLoader";

function ProductImage({ src, sizes = "64px", className, onLoad, ...props }) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const imgRef = useRef(null);

  function imageLoadedHandler() {
    setImageLoaded(true);
  }

  function handleOnLoad() {
    if (onLoad) onLoad();

    imageLoadedHandler();
  }

  useEffect(() => {
    setImageLoaded(false);
  }, [src]);

  useEffect(() => {
    // Check if the image is already loaded (it could be cached server side)
    if (imgRef.current && imgRef.current.complete) {
      setImageLoaded(true);
    }
  }, []);

  return (
    <div className={classNames("product-image-container", className)}>
      {src && (
        <Image
          ref={imgRef}
          loader={ImgixLoader}
          src={src}
          alt=""
          onLoad={handleOnLoad}
          fill
          sizes={sizes}
          className={classNames("product-image", imageLoaded && "loaded")}
          {...props}
        />
      )}
    </div>
  );
}

export default ProductImage;
